import React, { Fragment } from "react";

import { StorebrandKeycloak } from "@storebrand-digital/storebrand-auth";

const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  if (!StorebrandKeycloak.authenticated()) {
    StorebrandKeycloak.login();
    return <Fragment />;
  }
  return children;
};

export default ProtectedRoute;
